import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import PrivacyPolicy from "./PageComponents/PrivacyPolicy"
import TermsOfService from "./PageComponents/TermsOfService"
import OrganizerAgreement from "./PageComponents/OrganizerAgreement"
import Event from "./PageComponents/Event"
import EventsPage from "./PageComponents/EventsPage"
import MainApp from "./MainApp"
import AppDownload from "./PageComponents/AppDownload"
import PhysicalTickets from "./PageComponents/PhysicalTickets"
import WristbandsPdf from "./PageComponents/WristbandsPdf"
import CompletePayment from "./PageComponents/CompletePayment"
import TriviaInfo from "./PageComponents/TriviaInfo"
import UnsubscribePage from "./pages/UnsubscribePage"
import VotingPeriodPage from "./PageComponents/VotingPage"
import WalletInfo from "./PageComponents/WalletInfo/Index"
import DeepLinkRedirectPage from "./pages/WalletAccess"
import LoginPage from "./PageComponents/LoginPage"
import Dashbaord from "./PageComponents/Dashboard"
import StickersPDFPage from "./pages/StickersPDFScreen"
import CardPaymentVerification from "./PageComponents/CardPaymentVerification"
import AppNavBar from "./PageComponents/AppNavBar"

export default function App() {
  return (
    <Router>
      <div>
        <Switch>
          <Route
            path="/"
            component={MainApp}
            exact
          />
          <Route
            path="/staff/login"
            component={LoginPage}
            exact
          />
          <Route
            path="/dashboard"
            component={Dashbaord}
            exact
          />
          <Route
            path="/tos"
            component={TermsOfService}
            exact
          />
          <Route
            path="/privacy"
            component={PrivacyPolicy}
            exact
          />
          <Route
            path="/organizer-agreement"
            component={OrganizerAgreement}
            exact
          />
          <Route
            path="/app"
            component={AppDownload}
            exact
          />
          <Route
            path="/event/:eventCode"
            component={Event}
            exact
          />
          <Route
            path="/wallet"
            component={WalletInfo}
            exact
          />
          <Route
            path="/events/:eventCategory"
            component={EventsPage}
            exact
          />
          <Route
            path="/app/home/event/:eventCode"
            component={Event}
            exact
          />
          <Route
            path="/physical/tickets/:orderItemId"
            component={PhysicalTickets}
            exact
          />
          <Route
            path="/physical/wristbands/:orderItemId"
            component={WristbandsPdf}
            exact
          />
          <Route
            path="/physical/stickers/:orderItemId"
            component={StickersPDFPage}
            exact
          />
          <Route
            path="/complete/payment/:paymentId"
            component={CompletePayment}
            exact
          />
          <Route
            path="/trivia"
            component={TriviaInfo}
            exact
          />
          <Route
            path="/unsubscribe"
            component={UnsubscribePage}
            exact
          />
          <Route
            path="/voting/:periodId"
            component={VotingPeriodPage}
            exact
          />
          <Route
            path="/app/*"
            component={DeepLinkRedirectPage}
            exact
          />
          <Route
            path="/verify-payment/order/:paymentId"
            component={CardPaymentVerification}
            exact
          />
          <Route
            path="/gosl-aprm/registration"
            render={(routerProps) => {
              return (
                <div>
                  <AppNavBar />
                  <iframe
                    src="https://form.jotform.com/251059051872052"
                    style={{
                      width: "100%",
                      height: "100vh",
                      border: "none",
                    }}
                    title="APRM Registration"
                  ></iframe>
                </div>
              )
            }}
            exact
          />
          {/*<Route path="/.well-known/apple-app-site-association" component={IosUniversalLink} exact/>*/}
        </Switch>
      </div>
    </Router>
  )
}
